<template>
  <div class="swiper_box_list">
    <swiper class="brand_box" :options="swiperOption">
      <swiper-slide class="brand_list" v-for="(item,index) in Logos" :key="index">
        <img class="brand_img" :src="item.url">
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'hobbyswiper',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      Logos: this.$enumInfo.facturerLogo,
      swiperOption: {
        // autoplay: true,
        slidesPerView: 'auto',
        slidesPerColumn: 2,
        spaceBetween: 5
      }
    }
  },
  props: {
    startTime: String,
  },
}
</script>

<style>
.brand_box {
  /* 756*/
  width: 806px;
  height: 209px;
  position: relative;
}
.brand_box .brand_list {
  /* 244*/
  width: 263px;
  height: 100px;
  border-radius: 4px;
  /* border: 0.5px solid #e0e0e0; */
  /* padding: 12px; */
  margin-top: 0;
  margin-right: 0;
}
.brand_box .brand_img {
  /* width: 160px;
  height: 58.85px; */
  /* width: 120px; */
  height: 100px;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}
</style>

          


// WEBPACK FOOTER //
// src/components/swiper/manufacturer.vue